import { Routes } from '@angular/router';
import { LayoutComponent } from 'Admin/layout/layout.component'
import { OAuth2Service } from "@ngxsuit"

export const CHILDROUTES: Routes = [
    {
        path: 'stores/:store_id/seo', component: LayoutComponent,
        children: [
            {
                "path": "",
                "loadChildren": "SEO/pages/pageseo/pageseo.module#PageSeoModule",
                canActivate: [OAuth2Service]
            },
        ]
    }
];

export const MENUS = [];